
const firstHeader =['车型','科目','序号','科目名称','期初数','合计',]

const indexOne = [
    '1','2','3','4','5','6','7','8','9','10','11',
   
]
const carTypeIndex = ['1','2','3','4','5','6','7','8','9','10','11','12']
const carTypeItem = [
    '订单计划','销售计划','销售单价','收入合计','成本','物流费用','关税','成本合计','当月销售单价变动（usd/台）',
    '当月成本数据变动（usd/台）','利润','利润率',
]
const saleHeader = [
    '销售计划','销售单价','收入合计','成本','物流费用','关税','运营费及其他','成本合计','当月变动数据','利润','利润率',


]
const border = []

export { carTypeIndex,carTypeItem,firstHeader,indexOne, saleHeader,border }